import { Link } from 'react-router-dom'

const CREWS = [
  {
    slug: 'audio',
    title: 'Audio',
    desc: 'Mixer, monitors, microphones, speaker installation.',
  },
  {
    slug: 'video',
    title: 'Video',
    desc: 'Technical director, switcher, camera, media, installation.',
  },
  {
    slug: 'stage',
    title: 'Stage',
    desc: 'Stage keyman, mic handler, furniture, runner.',
  },
  {
    slug: 'it',
    title: 'IT',
    desc: 'Streaming, network, and technical support.',
  },
] as const

export default function LearnIndex() {
  return (
    <div className="learn-index">
      <header className="crew-header">
        <p className="eyebrow">Learning</p>
        <h1>Pick your crew</h1>
        <p className="lead">Four crews. Five tracks. One convention.</p>
      </header>
      <div className="learn-index__grid">
        {CREWS.map((c) => (
          <Link
            key={c.slug}
            to={`/learn/${c.slug}`}
            className="portal-card"
            data-crew={c.slug}
          >
            <span className="portal-title">{c.title}</span>
            <span className="portal-desc">{c.desc}</span>
          </Link>
        ))}
      </div>
    </div>
  )
}
